<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <div
    class="founder flex flex-col items-center max-w-240.5 pb-5.5 pt-10 lg:flex-row lg:mx-auto lg:items-start lg:justify-between lg:py-6"
  >
    <div class="web3 relative">
      <NuxtImg
        loading="lazy"
        alt="Phone"
        class="w-73.25 h-81 object-cover object-top lg:w-80.75 lg:h-137.25"
        src="/images/nft/phone-5.webp"
      />
    </div>
    <div class="mt-6 px-11.5 lg:max-w-115 lg:mt-38.5 lg:px-0">
      <div
        class="text-[28px] leading-[42px] tracking-wide text-white text-center lg:text-left"
      >
        {{ t('your') }} <span class="text-[#ff9595]">{{ t('web3') }}</span>
        {{ t('homepage') }}
      </div>
      <div
        class="max-w-115 mt-5 text-center text-[18px] leading-[27px] tracking-wide text-[#CECECE] lg:mt-8.5 lg:text-left"
      >
        {{ t('get-a-short') }}
        <span class="text-[#57A5FF]">{{ t('belong-net-yourname') }}</span>
        {{ t('profile-with-your-nft') }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.founder {
  @apply relative;
  &:after {
    @apply absolute bottom-0 w-full h-42;
    background: linear-gradient(180deg, rgba(21, 21, 21, 0) 0%, #151515 68.05%);
    content: '';
  }
}

.web3 {
  &::after {
    @apply absolute bottom-0 w-full h-18 z-2 left-0 right-0;
    background: linear-gradient(0deg, #151515 0%, rgba(34, 34, 34, 0) 100%);
    content: '';
  }
}
</style>
